import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IButtonProps, TButtonTheme } from '@cian/ui-kit/button/types';
import { useDispatch, useSelector } from 'react-redux';

import { onEntryAutorisationPopupOpen, onEntryPointClick } from './analytics/analytics';
import { useConsultantCianChat } from './hooks/useConsultantCianChat';
import { openAutorisationMotivationConsultantCianChat } from '../../actions/consultantCianChat/actions';
import { getGaLabel, getRegionId } from '../../selectors/analytics';
import { getUser } from '../../selectors/user';

interface ISendMessageButtonContainerProps {
  title: string;
  ariaLabel?: string;
  size: IButtonProps['size'];
  theme: TButtonTheme;
  beforeIcon?: React.JSX.Element;
  noMarginTop?: boolean;
  placeType?: string;
  tabIndex?: number;
  ref?: React.RefObject<HTMLButtonElement>;
}

export const SendMessageButtonContainer = ({
  size,
  title,
  theme,
  beforeIcon,
  ariaLabel,

  tabIndex,
  ref,
}: ISendMessageButtonContainerProps) => {
  const { handleOpenChat } = useConsultantCianChat();
  const regionId = useSelector(getRegionId);
  const customLabel = useSelector(getGaLabel);
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const isAuthenticated = user?.isAuthenticated;

  const onClick = React.useCallback(() => {
    onEntryPointClick({ regionId });
    if (!isAuthenticated) {
      dispatch(openAutorisationMotivationConsultantCianChat());
      onEntryAutorisationPopupOpen({ regionId, customPageURL: customLabel });
    } else {
      handleOpenChat();
    }
  }, [dispatch, handleOpenChat, isAuthenticated]);

  return (
    <Button
      data-testid="ConsultantChatButton"
      theme={theme}
      size={size}
      onClick={onClick}
      beforeIcon={beforeIcon}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      ref={ref}
    >
      {title}
    </Button>
  );
};
